import React from "react";
import { connect } from "react-redux";
import { Popup, Button, DateBox, Accordion, List, TextBox } from "devextreme-react";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { AgendarCitaApi } from "../../../../../services/solicitudesAgendaSelApi";
import { openCloseModalAgendar, loadDataSelected, setWorkerSelected, openToast, loadDataGrid, loading } from "../actions";
import { formatDateForFilter } from "../../../../../helpers/dateFormat";
import Moment from "moment";
import validaciones from "../../../../../helpers/validaciones";

class ModalAgendar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      schedulingData: [],
      listaCentros: [],
      trabajador: {},
      workerId: null,
      selectedItems: [],
      dateSelected: [],
      externalCodeSelected: [],
    };
    this.selectionChanged = this.selectionChanged.bind(this);
    this.selectedItemsChanged = this.selectedItemsChanged.bind(this);
  }

  selectionChanged(e) {
    let newItems = [...this.state.selectedItems];
    e.removedItems.forEach((item) => {
      const index = newItems.indexOf(item);
      if (index >= 0) {
        newItems.splice(index, 1);
      }
    });
    if (e.addedItems.length) {
      newItems = [...newItems, ...e.addedItems];
    }
    this.setState({
      selectedItems: newItems,
    });
  }

  selectedItemsChanged(e) {
    this.setState({
      selectedItems: e,
    });
  }

  setModalAgendar() {
    const workerRequestId = this.props.dataSelected ? this.props.dataSelected : null;
    const trabajador = this.props.selectedSolicitud.Workers.find((item) => item.Id === workerRequestId);

    const pools = this.props.selectedSolicitud.Pools.map((item) => ({
      type: "pool",
      Name: item.Description,
      RequestPoolId: item.Id,
      SchedulingDate: null,
      AchsOfficeDescription: item.AchsOfficeDescription,
      AchsOfficeCode: item.AchsOfficeCode,
      dateSelected: null,
      ExternalCode: null,
      externalCodeSelected: null,
    }));

    const additionalExams = this.props.selectedSolicitud.AdditionalExams.map((item) => ({
      type: "exam",
      Name: item.ExamDescription,
      RequestExamId: item.Id,
      SchedulingDate: null,
      AchsOfficeDescription: item.AchsOfficeDescription,
      AchsOfficeCode: item.AchsOfficeCode,
      dateSelected: null,
      ExternalCode: null,
      externalCodeSelected: null,
    }));

    const psychologicalExams = this.props.selectedSolicitud.PsychologicalExams.map((item) => ({
      type: "exam",
      Name: item.ExamDescription,
      RequestExamId: item.Id,
      SchedulingDate: null,
      AchsOfficeDescription: item.AchsOfficeDescription,
      AchsOfficeCode: item.AchsOfficeCode,
      dateSelected: null,
      ExternalCode: null,
      externalCodeSelected: null,
    }));

    const data = [...pools, ...additionalExams, ...psychologicalExams].map((e, i) => { e.dataId = i; return e; });
    const centros = [...data].reduce((x, y) => x.findIndex((e) => e.AchsOfficeCode === y.AchsOfficeCode) < 0 ? [...x, { AchsOfficeDescription: y.AchsOfficeDescription, AchsOfficeCode: y.AchsOfficeCode }] : x, []);
    this.setState({
      schedulingData: data, trabajador, listaCentros: centros, workerId: workerRequestId,
    });
  }

  componentDidMount() {
    this.setModalAgendar();
  }

  handleClose = () => {
    this.props.dispatch(setWorkerSelected(null));
    this.props.dispatch(openCloseModalAgendar(false));
  }

  handleAgendarCita = async (data) => {
    const validation = data.find((e) => e.dateSelected === null);

    if (validation) {
      this.props.dispatch(openToast({
        isToastOpen: true,
        msgToast: "La hora y fecha son requeridas.",
        typeStyle: "error",
        // displayTime: 5000,
      }));
      return;
    }

    if (this.state.workerId === "S/D") {
      this.setState({ workerId: null });
    }

    const requestData = {
      RequestId: this.props.selectedSolicitud.Id,
      WorkersScheduling: [
        {
          WorkerId: this.state.workerId,
          scheduling: data.map((e) => {
            if (e.type === "pool") {
              return {
                RequestPoolId: e.RequestPoolId,
                SchedulingDate: e.dateSelected,
                ExternalCode: e.externalCodeSelected,
              };
            } else if (e.type === "exam") {
              return {
                RequestExamId: e.RequestExamId,
                SchedulingDate: e.dateSelected,
                ExternalCode: e.externalCodeSelected,
              };
            }
            return null;
          }).filter((f) => f),
        },
      ],
    };

    try {
      this.props.dispatch(loading(true));
      const request = await AgendarCitaApi(requestData);
      if (request.status === 200 || true) {
        this.doGetComplains();
        this.props.dispatch(setWorkerSelected(null));
        this.props.dispatch(openCloseModalAgendar(false));
        this.props.dispatch(loadDataSelected(this.props.selectedSolicitud.Id));
      }
      this.props.dispatch(loading(false));
    } catch (err) {
      this.props.dispatch(loading(false));
    }
  }

  handleChangeDate = (event, item) => {
    const _newDate = this.state.schedulingData.map((e) => {
      if (e.AchsOfficeCode === item.AchsOfficeCode) {
        e.dateSelected = event.value;
        return e;
      }
      return e;
    });
    const _newDateSelected = this.state.dateSelected.filter((e) => e.idCentro !== item.AchsOfficeCode);
    this.setState({
      dateSelected: [..._newDateSelected, { idCentro: item.AchsOfficeCode, value: event.value }],
      schedulingData: _newDate,
    });
  }

  handleChangeDateElement = (event, item) => {
    const _newList = this.state.schedulingData.map((e) => {
      if (e.dataId === item.dataId) {
        e.dateSelected = event.value;
        return e;
      }
      return e;
    });
    if (event.value !== item.dateSelected) {
      const _newDateSelected = this.state.dateSelected.filter((e) => e.idCentro !== item.AchsOfficeCode);
      this.setState({
        dateSelected: _newDateSelected,
        schedulingData: _newList,
      });
    } else {
      const _dates = this.state.schedulingData.reduce((x, y) => x.findIndex((e) => e.dateSelected === y.dateSelected) < 0 ? [...x, y] : x, []);
      if (_dates.length === 1) {
        const _newDateSelected = this.state.dateSelected.filter((e) => e.idCentro !== item.AchsOfficeCode);
        this.setState({
          dateSelected: [..._newDateSelected, { idCentro: item.AchsOfficeCode, value: event.value }],
          schedulingData: _newList,
        });
      } else { this.setState({ schedulingData: _newList }); }
    }
  }

  handleChangeNumberAttention = (event, item) => {
    const _newNumberAttention = this.state.schedulingData.map((e) => {
      if (e.AchsOfficeCode === item.AchsOfficeCode) {
        e.externalCodeSelected = event.value;
        return e;
      }
      return e;
    });
    const _newNumberAttentionSelected = this.state.externalCodeSelected.filter((e) => e.idCentro !== item.AchsOfficeCode);
    this.setState({
      externalCodeSelected: [..._newNumberAttentionSelected, { idCentro: item.AchsOfficeCode, value: event.value }],
      schedulingData: _newNumberAttention,
    });
  }

  handleChangeNumberAttentionElement = (event, item) => {
    const _newList = this.state.schedulingData.map((e) => {
      if (e.dataId === item.dataId) {
        e.externalCodeSelected = event.value;
        return e;
      }
      return e;
    });
    if (event.value !== item.externalCodeSelected) {
      const _newExternalCodeSelected = this.state.externalCodeSelected.filter((e) => e.idCentro !== item.AchsOfficeCode);
      this.setState({
        externalCodeSelected: _newExternalCodeSelected,
        schedulingData: _newList,
      });
    } else {
      const _dates = this.state.schedulingData.reduce((x, y) => x.findIndex((e) => e.externalCodeSelected === y.externalCodeSelected) < 0 ? [...x, y] : x, []);
      if (_dates.length === 1) {
        const _newExternalCodeSelected = this.state.externalCodeSelected.filter((e) => e.idCentro !== item.AchsOfficeCode);
        this.setState({
          externalCodeSelected: [..._newExternalCodeSelected, { idCentro: item.AchsOfficeCode, value: event.value }],
          schedulingData: _newList,
        });
      } else { this.setState({ schedulingData: _newList }); }
    }
  }

  handleChangeNumberAttention = (event, item) => {
    const _newNumberAttention = this.state.schedulingData.map((e) => {
      if (e.AchsOfficeCode === item.AchsOfficeCode) {
        e.externalCodeSelected = event.value;
        return e;
      }
      return e;
    });
    const _newNumberAttentionSelected = this.state.externalCodeSelected.filter((e) => e.idCentro !== item.AchsOfficeCode);
    this.setState({
      externalCodeSelected: [..._newNumberAttentionSelected, { idCentro: item.AchsOfficeCode, value: event.value }],
      schedulingData: _newNumberAttention,
    });
  }

  handleChangeNumberAttentionElement = (event, item) => {
    const _newList = this.state.schedulingData.map((e) => {
      if (e.dataId === item.dataId) {
        e.externalCodeSelected = event.value;
        return e;
      }
      return e;
    });
    if (event.value !== item.externalCodeSelected) {
      const _newExternalCodeSelected = this.state.externalCodeSelected.filter((e) => e.idCentro !== item.AchsOfficeCode);
      this.setState({
        externalCodeSelected: _newExternalCodeSelected,
        schedulingData: _newList,
      });
    } else {
      const _dates = this.state.schedulingData.reduce((x, y) => x.findIndex((e) => e.externalCodeSelected === y.externalCodeSelected) < 0 ? [...x, y] : x, []);
      if (_dates.length === 1) {
        const _newExternalCodeSelected = this.state.externalCodeSelected.filter((e) => e.idCentro !== item.AchsOfficeCode);
        this.setState({
          externalCodeSelected: [..._newExternalCodeSelected, { idCentro: item.AchsOfficeCode, value: event.value }],
          schedulingData: _newList,
        });
      } else { this.setState({ schedulingData: _newList }); }
    }
  }

  doGetComplains = (data) => {
    const filtros = {
      from: formatDateForFilter(Moment().subtract(1, "year")),
      to: formatDateForFilter(Moment()),
      companyRut: this.props.companyId,
      PetitionerRut: this.props.userData.RUT,
      StatusId: this.props.selectedTipoSolicitud.value.value,
    };
    if (validaciones.emptyText(this.props.sucursalId)) {
      filtros.idSucursal = this.props.sucursalId;
    }
    this.props.dispatch(loadDataGrid(filtros));
  }

  listaCentros = (list) => {
    const requestData = this.props.request;
    return (
      <React.Fragment>
        <div className="col-12">
          <Accordion
            collapsible
            activeStateEnabled={false}
            focusStateEnabled={false}
            hoverStateEnabled={false}
            className="accordion-prestaciones-inbox"
            dataSource={this.state.listaCentros}
            defaultSelectedIndex={0}
            multiple
            onItemTitleClick={(e) => {
              const _list = list.filter((ee) => e.itemData.AchsOfficeCode === ee.AchsOfficeCode);
              if (e.event.target.classList.value === "dx-texteditor-input" || e.event.target.classList.value === "dx-dropdowneditor-icon" || _list.length <= 1) {
                e.event.stopPropagation();
                e.event.preventDefault();
              }
            }}
            onItemRendered={(e) => {
              const _list = list.filter((ee) => e.itemData.AchsOfficeCode === ee.AchsOfficeCode);
              if (_list.length <= 1) {
                e.element.firstChild.firstChild.firstChild.classList.add("hidden-arrow-title");
              }
              e.component.collapseItem(e.itemIndex);
            }}
            onSelectionChanged={this.selectionChanged}
            itemTitleComponent={(data) => {
              const isSelected = this.state.selectedItems.find((e) => e.AchsOfficeCode === data.AchsOfficeCode);
              const dateSelected = this.state.dateSelected.find((e) => e.idCentro === data.AchsOfficeCode);
              const externalCodeSelected = this.state.externalCodeSelected.find((e) => e.idCentro === data.AchsOfficeCode);
              return (
                <React.Fragment>
                  <div className="titleContent">
                    <div className="row">
                      <div className="col-4">
                    Centro:
                      </div>
                      <div className="col-8">
                        {data.AchsOfficeDescription}
                      </div>
                    </div>
                    {!isSelected && (
                      <React.Fragment>
                        <div className="row">
                          <div className="col-4">
                      Baterías:
                          </div>
                          <div className="col-8">
                            <ul className="listPoolExam">
                              {list.filter((e) => e.type === "pool" && e.AchsOfficeCode === data.AchsOfficeCode)
                                .map((e, i) => <li key={`exams_1_${i}`} className="span_exams">{e.Name}{e.dateSelected ? <span> ({Moment(new Date(e.dateSelected)).format("DD-MM-YYYY HH:mm")})</span> : ""}</li>)}
                            </ul>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4">
                      Prestaciones:
                          </div>
                          <div className="col-8">
                            <ul className="listPoolExam">
                              {list.filter((e) => e.type === "exam" && e.AchsOfficeCode === data.AchsOfficeCode)
                                .map((e, i) => <li key={`exams_2_${i}`} className="span_exams">{e.Name}{e.dateSelected ? <span> ({Moment(new Date(e.dateSelected)).format("DD-MM-YYYY HH:mm")})</span> : ""}</li>)}
                            </ul>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6" style={{ marginTop: 15 }}>
                            <div className="row"> <div className="col-6">Hora y fecha</div></div>
                            <div className="row">
                              <div className="col-12">
                                <DateBox
                                  width="100%"
                                  type="datetime"
                                  value={dateSelected && dateSelected.value ? Moment(dateSelected.value).format() : null}
                                  min={requestData.ProposalDate ? Moment(requestData.ProposalDate).subtract(30, "days").format() : new Date()}
                                  onValueChanged={(e) => this.handleChangeDate(e, data)}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-6" style={{ marginTop: 15 }}>
                            <div className="row"> <div className="col-12">Orden de atención(Dentalink)</div></div>
                            <div className="row">
                              <div className="col-12">
                                <TextBox
                                  id="idDentalinkGroup"
                                  maxLength={20}
                                  width="100%"
                                  onValueChanged={(e) => this.handleChangeNumberAttention(e, data)}
                                  defaultValue={externalCodeSelected && externalCodeSelected.value ? externalCodeSelected.value : null}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </React.Fragment>
              );
            }
            }
            itemComponent={(item) => this.listaBaterias(list.filter((e) => e.AchsOfficeCode === item.AchsOfficeCode))}
            noDataText=""
          />
        </div>
      </React.Fragment>
    );
  }

  listaBaterias = (list) => {
    const requestData = this.props.request;
    return (<React.Fragment>
      <List
        collapsible
        activeStateEnabled={false}
        focusStateEnabled={false}
        hoverStateEnabled={false}
        items={list}
        itemComponent={(item) => (
          <React.Fragment>
            <div>
              <div style={{ margin: "20px 0 20px 0" }}></div>
              <div className="row">
                <div className="col-6" style={{ fontWeight: "bold" }}>{item.Name}</div>
              </div>
              <div className="row">
                <div className="col-6" style={{ marginTop: 15, marginBottom: 30 }}>
                    <div className="col-12">
                    <div className="row"> <div className="col-6">Hora y fecha</div></div>
                      <DateBox
                        type="datetime"
                        width="100%"
                        value={item.dateSelected && item.dateSelected ? Moment(item.dateSelected).format() : ""}
                        min={requestData.ProposalDate ? Moment(requestData.ProposalDate).subtract(30, "days").format() : new Date()}
                        max={this.state.schedulingData[0].dateSelected ? Moment(this.state.schedulingData[0].dateSelected).add('year', 1).format() : Moment().add('year', 1).format()}
                        onValueChanged={(e) => this.handleChangeDateElement(e, item)}
                      />
                    </div>
                </div>
                <div className="col-6" style={{ marginTop: 15, marginBottom: 30 }}>
                <div className="col-12">
                      <div className="row"> <div className="col-6">Orden de atención(Dentalink)</div></div>
                        <TextBox
                          id="idDentalink"
                          maxLength={20}
                          width="100%"
                          onValueChanged={(e) => this.handleChangeNumberAttentionElement(e, item)}
                          defaultValue={item.externalCodeSelected ? item.externalCodeSelected : null}
                        />
                    </div>
                </div>
                <br/><br/><br/>
              </div>
            </div>
          </React.Fragment>
        )}
      />
            </React.Fragment>);
  }

  render() {
    const { trabajador } = this.state;
    return (
      <Popup
        visible={this.props.isOpenModalAgendar}
        showTitle
        title="Confirmar cupo"
        onHidden={this.handleClose}
        maxWidth={760}
        maxHeight={700}
        dragEnabled={false}
        className="modalConfirmarCupo"
      >
        <div style={{ }}>
          {this.state.isLoading && <LoadingOverlay />}
          <div className="row">
            <div className="col-2" style={{ marginRight: "50px" }}>Trabajador</div>
            <div className="col-sm-4" style={{ fontWeight: "bold" }}>
              <div className="row">{trabajador != null && trabajador.Name ? trabajador.Name : "Sin nombre"} </div>
              <div className="row">{trabajador != null && trabajador.DocumentNumber ? trabajador.DocumentNumber : ""}</div>
            </div>
          </div>
          <div style={{ border: "solid 0.5px rgba(238, 238, 238)", margin: "20px 0 20px 0" }}></div>
          <div
            className="row"
            style={{
              height: "100%", paddingBottom: "80px", marginLeft: 0, marginRight: 0,
            }}
          >
            {this.listaCentros(this.state.schedulingData)}
          </div>
          <div className="button-row-for-agendar">
            <div style={{ marginRight: "auto", marginLeft: "auto" }}>
              <Button onClick={this.handleClose} text="Cancelar" />
            </div>
            <div style={{ marginRight: "auto", marginLeft: "auto" }}>
              <Button onClick={() => this.handleAgendarCita(this.state.schedulingData)} type="success" text="Confirmar cita" />
            </div>
          </div>
        </div>
      </Popup>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.inboxSolicitudes.isLoading,
  listaSolicitantes: state.inboxSolicitudes.listaSolicitantes,
  request: state.inboxSolicitudes.request,
  dataSelected: state.inboxSolicitudes.dataSelected,
  isOpenModalAgendar: state.inboxSolicitudes.isOpenModalAgendar,
  selectedSolicitud: state.inboxSolicitudes.selectedSolicitud,
  selectedTipoSolicitud: state.inboxSolicitudes.selectedTipoSolicitud,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  userData: state.global.userData,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalAgendar);
